import { breakpointsTailwind } from "@vueuse/core";
import { useBreakpoints } from "@vueuse/core";

const breakpoints = useBreakpoints(breakpointsTailwind);

export const isMobile = breakpoints.smaller("lg");
